<template>
  <qx-card-form title="保费设置">
    <qx-custom-form
      v-if="originData.length !== 0"
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      originData: [],
      baseForm: {
        form: [
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async sub () {
      const data = await this.cacheData();
      const result = {};
      data.premium.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          result[`creditRatingRuleFee_0_${index}.${key}`] = item[key];
        });
      });
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      this.originData.forEach((item, index) => {
        item.insuranceFee = res[String(index)];
      });
      return {
        premium: this.originData,
      };
    },
    async init (data = {}) {
      this.originData = data.premium;
      this.baseForm.form = [];
      data.premium.forEach((item, index) => {
        this.baseForm.form.push({
          label: `运费${item.maxFee === '-1' ? '大于' : ''}${item.minFee / 100}元${item.maxFee ? '-' + item.maxFee + '元' : ''}`,
          value: String(index),
          type: 'input',
          unit: '元',
          default: item.insuranceFee / 100,
        });
        this.baseForm.rules[String(index)] = [
          { required: true, message: '请输入联系手机', trigger: 'blur' },
        ];
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
